'use memo';

import { AgxColumn, AgxNotificationBox } from '@urbanx/agx.ui-components2';
import AgreementDetailsComponent from './AgreementDetails';
import { ListingAgreementDetails } from '@urbanx/agx.campaigns.client';

export const QLDAgreementTypeStageSteps = ({
  agreementDetails,
  onAgreementDetailsUpdated,
  isOpen,
  exceededGap,
}: {
  agreementDetails?: ListingAgreementDetails;
  onAgreementDetailsUpdated: (updated: { id: string; value: ListingAgreementDetails }) => void;
  isOpen: boolean;
  exceededGap: boolean;
}) => {
  return (
    <AgxColumn gap="spacing-xl" fill>
      {agreementDetails && (
        <>
          <AgreementDetailsComponent
            id="agreementDetails"
            value={agreementDetails}
            onValueChange={onAgreementDetailsUpdated}
          />
          {isOpen === false && exceededGap && (
            <AgxNotificationBox
              type="danger"
              heading=""
              body="Appointment period exceeds 90 days"
            />
          )}
        </>
      )}
    </AgxColumn>
  );
};

export default QLDAgreementTypeStageSteps;
